export const contactsData = {
    email: 'sirshikher@gmail.com',
    phone: '+91 8920028634',
    address: 'Gonda,India',

    sheetAPI: ''
}